export const CLOSE_DELETE_TIMEOUT = 1000;
